import { gql } from "@apollo/client";

const GET_INVOICE_UPLOAD_UNITS = gql`
  query getInvoiceUploadUnits(
    $clientIdentifier: String!
    $uploadUnitStatuses: [InvoiceUploadUnitStatus]
    $skip: Int
    $take: Int
    $sortBy: InvoiceUploadUnitSortBy
    $sortDirection: SortDirection
  ) {
    invoiceUploadUnits(
      clientIdentifier: $clientIdentifier
      uploadUnitStatuses: $uploadUnitStatuses
      skip: $skip
      take: $take
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      totalCount
      items {
        id
        createdAt
        rejectionComment {
          createdByUser {
            id
            firstName
            lastName
          }
          content
          createdAt
          id
        }
        emailDetails {
          isHtml
          messageId
          previewBody
          rawBody
          receivedDate
          recipients
          sentFromEmail
          subject
        }
        invalidAttachments {
          contentType
          errorMessage
          fileName
        }
        invoiceDocuments {
          id
          invoiceRecipientEmails
          invoiceRecipientGln
          serviceType
          userMessage
          status
          file {
            fileType
            id
            fileName
          }
          relatedDocuments {
            id
            status
            file {
              fileType
              id
              fileName
            }
          }
          comments(skip: 0, take: 5) {
            totalCount
            items {
              content
              createdAt
              createdByUser {
                id
                firstName
                lastName
              }
              id
            }
          }
        }
        isBlacklisted
        modifiedAt
        status
        statusHistory {
          setAt
          status
        }
        uploadSource
        uploadType
      }
    }
  }
`;

export default GET_INVOICE_UPLOAD_UNITS;
